<template>
    <v-container class="no-padding-mobile">
        <v-layout>
            <v-flex xs12 sm12 md12 lg10 offset-lg1 xl8 offset-xl2>
                <v-card class="mb-3">
                    <v-card-text class="text--primary">
                        <v-btn block outlined :to="{ name: 'map' }">
                            {{ $t("button.see_global_map") }}
                            <v-icon right>map</v-icon>
                        </v-btn>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-app-bar-nav-icon>
                            <v-progress-circular
                                :size="28"
                                :width="3"
                                indeterminate
                                color="white"
                                v-if="$apollo.queries.plans.loading"
                            ></v-progress-circular>
                            <v-icon v-else>map</v-icon>
                        </v-app-bar-nav-icon>

                        <v-toolbar-title v-t="'title.plans'"></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn rounded dark color="green" @click="addPlan">
                            {{ $t("button.new") }}
                            <v-icon right>add_circle</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="text--primary" v-if="newPlan">
                        <FormPlan
                            adding
                            :loading="loading"
                            @cancel="newPlan = null"
                            @submit="saveNew"
                        />
                    </v-card-text>
                    <v-list v-if="plans.length > 0" two-line>
                        <v-list-group
                            v-for="(plan, i) in plans"
                            :key="plan._id"
                            v-model="plan.active"
                        >
                            <template v-slot:activator>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="plan.name"></v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn
                                            rounded
                                            outlined
                                            color="primary"
                                            @click.stop
                                            :to="{ name: 'plan-view', params: { id: plan._id } }"
                                        >
                                            {{ $t("button.see") }}
                                            <v-icon class="ml-1">map</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </template>

                            <v-card style="min-height: 600px;">
                                <FormPlan
                                    v-if="editing && plan.active"
                                    :loading="loading"
                                    :value="editing"
                                    @cancel="closeAll"
                                    @remove="remove(i)"
                                    @submit="saveExisting($event, i)"
                                />
                            </v-card>
                        </v-list-group>
                    </v-list>
                    <v-card-text class="text--primary" v-else-if="!newPlan">
                        <div class="headline text-xs-center">{{ $t("message.no_plans_yet") }}</div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import loadingMixin from "@/mixins/loading"
import FormPlan from "@/components/FormPlan"
import { mapGetters, mapActions } from "vuex"
import Vue from "vue"
export default {
    mixins: [loadingMixin],
    components: { FormPlan },
    apollo: {
        plans: {
            query: require("@/graphql/plan/plans.gql"),
            update({ plans }) {
                if (this.$route.params.id) {
                    const index = plans.findIndex((c) => c._id == this.$route.params.id)
                    this.editing = Object.assign({}, plans[index])
                    plans[index].active = true
                }
                return plans
            },
        },
    },
    methods: {
        async upsert(data) {
            this.loading = true
            this.errors = []
            try {
                const {
                    data: { upsertPlan },
                    errors,
                } = await this.$apollo.mutate({
                    mutation: require("@/graphql/plan/upsertPlan.gql"),
                    variables: {
                        _id: data._id || null,
                        name: data.name,
                        description: data.description,
                        file: data.file,
                        image: data.image,
                    },
                })
                this.loading = false
                if (upsertPlan) {
                    this.$apollo.queries.plans.refresh()
                    this.$notify({
                        title: this.$i18n.t("notify.updated"),
                        type: "success",
                    })
                }

                return upsertPlan
            } catch (error) {
                this.errors = error.graphQLErrors.map((e) => e.message)
            }
            this.loading = false
        },
        async remove(index) {
            const data = this.plans[index]
            this.loading = true
            this.errors = []
            try {
                const {
                    data: { removePlan },
                    errors,
                } = await this.$apollo.mutate({
                    mutation: require("@/graphql/plan/removePlan.gql"),
                    variables: {
                        _id: data._id || null,
                    },
                })

                if (removePlan) {
                    Vue.delete(this.plans, index)
                    this.$notify({
                        title: this.$i18n.t("notify.removed"),
                        type: "success",
                    })
                }
            } catch (error) {
                this.errors = error.graphQLErrors.map((e) => e.message)
            }
            this.loading = false
        },
        async saveNew(plan) {
            const upsertPlan = await this.upsert(plan)
            this.newPlan = null
        },
        async saveExisting(plan, index) {
            try {
                delete plan.active

                const upsertPlan = await this.upsert(plan)
                console.log(upsertPlan)
                this.plans[index] = upsertPlan
            } catch (error) {}
        },
        addPlan() {
            if (!this.newPlan) {
                this.newPlan = true
            }
        },
        closeAll() {
            for (const key in this.plans) {
                if (this.plans[key].active) {
                    this.plans[key].active = false
                }
            }
        },
    },
    watch: {
        plans: {
            handler(value) {
                const index = value.findIndex((c) => c.active)
                if (index === -1 && this.$route.params.id) {
                    this.editing = null
                    this.$router.replace({ name: "plans" })
                }
                if (index != -1) {
                    const selected = value[index]
                    if (this.$route.params.id !== selected._id) {
                        this.$router.replace({
                            name: "plans-id",
                            params: { id: selected._id },
                        })
                    }
                    this.editing = selected
                }
            },
            deep: true,
        },
    },

    data() {
        return {
            editing: null,
            errors: [],
            rules: {
                required: (value) => !!value || this.$t("error.required"),
            },
            plans: [],
            newPlan: null,
        }
    },
}
</script>
